import script from "./AccordionCardHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccordionCardHeader.vue?vue&type=script&setup=true&lang=ts"

import "./AccordionCardHeader.vue?vue&type=style&index=0&id=29cacfb7&lang=scss"

const __exports__ = script;

export default __exports__